<template>
  <label :for="label" class="search-language">
    <input
      :id="label"
      :checked="checked"
      class="search-language__checkbox"
      type="checkbox"
      @change="addToQuery({ name, path })">
    <label
      :for="label"
      class="search-language__checkbox-indicator">
    </label>
    <slot></slot>
  </label>
</template>

<script>
import * as types from '@/store/actionTypes'

export default {
  name: 'SearchLanguage',

  props: {
    name: {
      required: true,
      type: String
    },
    path: {
      required: true,
      type: String
    }
  },

  computed: {
    label() {
      return `search-checkbox-${this.path}`
    },
    checked() {
      return this.$store.getters.hasLanguage(this.name)
    }
  },

  methods: {
    addToQuery(payload) {
      if (!this.checked) {
        this.$store.commit(types.ADD_TO_QUERY, {
          payload,
          type: 'languages'
        })
      } else {
        this.$store.commit(types.REMOVE_FROM_QUERY, {
          path: payload.path,
          type: 'languages'
        })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-language {
  align-items: center;
  background-color: var(--color-white);
  border: 1px solid #cacfd2;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  padding: var(--spacing-third);

  &:not(:last-child) {
    margin-bottom: var(--spacing-third);
  }

  @media (--bp-desktop) {
    padding: var(--spacing-half);

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
}

.search-language__checkbox {
  display: none;
}

.search-language__checkbox-indicator {
  background-color: #fff;
  border: 1px solid var(--color-mine-shaft);
  border-radius: 3px;
  color: #000;
  display: block;
  height: 14px;
  margin-right: var(--spacing-third);
  position: relative;
  width: 14px;
  z-index: 1;
}

.search-language__checkbox:checked
  + .search-language__checkbox-indicator:before {
  content: '\f00c';
  font-family: 'FontAwesome';
  font-size: 12px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);

  @media (--ie11) {
    content: url('./../../../static/icons/check.svg');
    height: 12px;
    width: 12px;
  }
}

@media (--ie11) and (--bp-desktop) {
  .search-language:nth-child(1) {
    -ms-grid-column: 1;
    -ms-grid-row: 1;
    margin-right: 30px;
    margin-bottom: 15px;
  }

  .search-language:nth-child(2) {
    -ms-grid-column: 2;
    -ms-grid-row: 1;
    margin-bottom: 15px;
  }

  .search-language:nth-child(3) {
    -ms-grid-column: 1;
    -ms-grid-row: 2;
    margin-right: 30px;
    margin-bottom: 15px;
  }

  .search-language:nth-child(4) {
    -ms-grid-column: 2;
    -ms-grid-row: 2;
    margin-bottom: 15px;
  }

  .search-language:nth-child(5) {
    -ms-grid-column: 1;
    -ms-grid-row: 3;
    margin-right: 30px;
  }

  .search-language:nth-child(6) {
    -ms-grid-column: 2;
    -ms-grid-row: 3;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchLanguage.vue